<template>
  <div class="form-item" v-if="userMasterListItem">
    <el-form-item
      :label="userMasterListItem.name"
      :prop="itemHeadNameProps"
      :rules="[{ required: true, validator: checkName, trigger: 'blur' }]"
    >
      <el-input
        v-model.trim="userMasterListItem.headName"
        :placeholder="userMasterListItem.nameMsg"
      ></el-input>
    </el-form-item>
    <el-form-item
      :label="userMasterListItem.phone"
      :prop="itemHeadPhoneProps"
      class="phone-item"
      :rules="[
        {
          required: true,
          validator: checkPhone,
          trigger: 'blur',
        },
      ]"
    >
      <el-input
        v-model.trim="userMasterListItem.headPhone"
        :placeholder="userMasterListItem.phoneMsg"
      ></el-input>
      <div
        v-show="userMasterListItem.uid != 1"
        class="el-icon-error"
        @click="noticeCloseAdd(userMasterListItem)"
      ></div>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: "UserMasterItem",
  inheritAttrs: false,
  props: ["userMasterListItem", "itemHeadNameProps", "itemHeadPhoneProps"],

  data() {
    return {};
  },
  methods: {
    checkName(rule, value, callback) {
      if (!this.userMasterListItem.headName) {
        callback(new Error("请输入产权方负责人"));
      } else {
        callback();
      }
    },
    checkPhone(rule, value, callback) {
      let reg = this.$formRules.phone;
      if (!this.userMasterListItem.headPhone) {
        callback(new Error(this.$formRules.phoneMsg));
      } else if (!reg.test(this.userMasterListItem.headPhone)) {
        callback(new Error(this.$formRules.phoneMsg));
      } else {
        callback();
      }
    },
    noticeCloseAdd(item) {
      // 通知父组件改变数据，关闭当前项
      this.$emit("closeAdd", item);
    },
  },
};
</script>

<style lang="scss" scoped>
.form-item {
  width: 74%;
  min-width: 610px;
  padding-top: 20px;
  border-radius: 8px;
  margin-bottom: 10px;
  background: #f2f2f2;
  .phone-item {
    position: relative;
    .el-icon-error {
      position: absolute;
      top: -20px;
      right: -25px;
      &:before {
        color: #ff2b2b;
        font-size: 22px;
      }
    }
  }
}
</style>
